import I18n from '../../../config/i18n';
import { optionsFromTo } from '../../../utils/helpers';
import type { SearchFilter } from '../types';

export default function searchFilter(): SearchFilter {
  return {
    bedrooms: {
      title: `${I18n.t('host.amount_bedrooms')} ${I18n.t('host.ab')}`,
      options: optionsFromTo(1, 11),
    },
    bathrooms: {
      title: `${I18n.t('host.amount_bathrooms')} ${I18n.t('host.ab')}`,
      options: optionsFromTo(1, 11),
    },
    amenities: {
      title: I18n.t('search.filters.features'),
      options: [
        {
          value: 'pets',
          label: I18n.t('search.filters.pets'),
        },
        {
          value: 'pool',
          label: I18n.t('search.filters.pool'),
        },
        {
          value: 'pool_outside',
          label: I18n.t('search.filters.pool_outside'),
        },
        {
          value: 'pool_inside',
          label: I18n.t('search.filters.pool_inside'),
        },
        {
          value: 'sea_view',
          label: I18n.t('search.filters.ocean_view'),
        },
        {
          value: 'air_conditioning',
          label: I18n.t('search.filters.air_conditioning'),
        },
        {
          value: 'jacuzzi',
          label: I18n.t('search.filters.jacuzzi'),
        },
        {
          value: 'jacuzzi_outside',
          label: I18n.t('search.filters.jacuzzi_outside'),
        },
        {
          value: 'jacuzzi_inside',
          label: I18n.t('search.filters.jacuzzi_inside'),
        },
        {
          value: 'sauna',
          label: I18n.t('search.filters.sauna'),
        },
        {
          value: 'teambuilding',
          label: I18n.t('search.filters.teambuilding'),
        },
        {
          value: 'limited_mobility',
          label: I18n.t('search.filters.limited_mobility'),
        },
        {
          value: 'linen_included',
          label: I18n.t('search.filters.linen_included'),
        },
        {
          value: 'lake',
          label: I18n.t('search.filters.lake'),
        },
        {
          value: 'fenced_garden',
          label: I18n.t('search.filters.fenced_garden'),
        },
      ].sort((a, b) => {
        if ((a.label as string).toLocaleLowerCase() < (b.label as string).toLocaleLowerCase()) {
          return -1;
        }
        if ((a.label as string).toLocaleLowerCase() > (b.label as string).toLocaleLowerCase()) {
          return 1;
        }
        return 0;
      }),
    },
    distance_to_beach: {
      title: I18n.t('search.filters.distance_to_beach'),
      options: [
        {
          value: 0,
          label: I18n.t('search.filters.any'),
        },
        {
          value: 1,
          label: '&#8804; 1 km',
        },
        {
          value: 5,
          label: '&#8804; 5 km',
        },
        {
          value: 10,
          label: '&#8804; 10 km',
        },
      ],
    },
    accommodation_type: {
      title: I18n.t('search.filters.kind_of_property'),
      options: [
        {
          value: 'holiday_home',
          label: I18n.t('search.filters.holiday_home'),
        },
        {
          value: 'apartment',
          label: I18n.t('search.filters.apartment'),
        },
        {
          value: 'suite',
          label: I18n.t('search.filters.suite'),
        },
      ],
    },
    stars: {
      title: I18n.t('search.filters.stars'),
      options: [
        {
          value: 0,
          label: I18n.t('search.filters.any'),
        },
        {
          value: 3,
          label: '3+',
        },
        {
          value: 4,
          label: '4+',
        },
        {
          value: 5,
          label: '5',
        },
      ],
    },
  };
}
